export const addLayer = (layerId, group, exclusive, popup) => ({
  type: 'ADD_LAYER',
  id: layerId,
  group: group,
  exclusive: exclusive,
  popup: popup
})

export const removeLayer = (layerId) => ({
  type: 'REMOVE_LAYER',
  id: layerId
})

export const filterLayer = (layerId, prop) => ({
  type: 'FILTER_LAYER',
  id: layerId,
  prop: prop
})

export const orgFilterLayer = (cat) => ({
  type: 'ORG_FILTER_LAYER',
  id: cat
})

export const styleLayer = (layerId, paint) => ({
  type: 'STYLE_LAYER',
  id: layerId,
  paint: paint
})

export const setSection = (id) => ({
  type: 'SET_SECTION',
  section: id
})



// WEBPACK FOOTER //
// ./src/actions/index.js